/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UserType {
    Internal = 'Internal',
    External = 'External'
}


export function instanceOfUserType(value: any): boolean {
    for (const key in UserType) {
        if (Object.prototype.hasOwnProperty.call(UserType, key)) {
            if (UserType[key as keyof typeof UserType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserTypeFromJSON(json: any): UserType {
    return UserTypeFromJSONTyped(json, false);
}

export function UserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserType {
    return json as UserType;
}

export function UserTypeToJSON(value?: UserType | null): any {
    return value as any;
}

export function UserTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): UserType {
    return value as UserType;
}

